import React from 'react';
import cx from 'classnames';

import { Asterix } from 'components/Form/HelperText/HelperText';
import NoteField from 'components/BookingForm/NoteField/NoteField';
import useIsLoadedInsideIframe from 'hooks/useIsLoadedInsideIframe';
import {
  FAMILY_BOOKING_NOTE_MAX_LENGTH,
  setFamilyBookingNote,
} from 'redux/familyBookingSlice';
import { useAppDispatch, useAppSelector } from 'redux/reduxHooks';

import HomeAddressFields from './HomeAddressFields/HomeAddressFields';
import styles from './AdditionalInformation.module.scss';

const NOTE_PLACEHOLDER =
  'Ie. area of concern/pain, insurance info, requested days/times to come sooner if opening available, etc.';

interface AdditionalInformationProps {
  isHomeAddressDisplayed: boolean;
  isNoteRequired?: boolean;
}

const AdditionalInformation = ({
  isHomeAddressDisplayed,
  isNoteRequired = false,
}: AdditionalInformationProps) => {
  const dispatch = useAppDispatch();

  const note = useAppSelector((state) => state.familyBookingSlice.note);

  const isLoadedInsideIframe = useIsLoadedInsideIframe();

  const containerClassName = cx({
    [styles['container']]: true,
    [styles['container-iframe']]: isLoadedInsideIframe,
  });

  return (
    <div className={containerClassName}>
      <div className={styles['section']}>
        <div className={styles['header-section']}>
          <div className={styles['title']}>Additional Information</div>
        </div>

        <div className={styles['body-section']}>
          {isHomeAddressDisplayed && <HomeAddressFields />}

          <div className={styles['field-label']}>
            Anything else we should know?
            {isNoteRequired && (
              <>
                {' '}
                <Asterix error={'required'} />
              </>
            )}
          </div>

          <NoteField
            value={note}
            onChange={(value) => dispatch(setFamilyBookingNote(value))}
            placeholder={NOTE_PLACEHOLDER}
            maxLength={FAMILY_BOOKING_NOTE_MAX_LENGTH}
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionalInformation;
